export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="18"
    width="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 0a9 9 0 109 9 9.01 9.01 0 00-9-9zm-.346 4.154a1.038 1.038 0 110 2.077 1.038 1.038 0 010-2.077zm1.038 9.692a1.385 1.385 0 01-1.384-1.385V9a.692.692 0 010-1.385A1.385 1.385 0 019.692 9v3.461a.692.692 0 010 1.385z"
      fill="#021B3D"
      fillOpacity=".36"
    />
  </svg>
);
